import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import useProductListCSVDownload from '../../../../queries/useProductListCSVDownload';
import withErrorBoundary from '../../../../../core/components/errors/withErrorBoundary';
import FileDownloadButton from '../../../../../core/components/FileDownloadButton';

const ProductListCSVDownloadButton = () => {
    const { startDownload, requestFailed, loading } =
        useProductListCSVDownload();

    return (
        <FileDownloadButton
            outline
            startDownload={startDownload}
            requestFailed={requestFailed}
            loading={loading}
        >
            <FormattedMessage id="download stock list as csv" />
        </FileDownloadButton>
    );
};

export default memo(withErrorBoundary(ProductListCSVDownloadButton));
